import { render } from "./BasketPopover.vue?vue&type=template&id=9b515a4e&scoped=true"
import script from "./BasketPopover.vue?vue&type=script&lang=js"
export * from "./BasketPopover.vue?vue&type=script&lang=js"

import "./BasketPopover.vue?vue&type=style&index=0&id=9b515a4e&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b515a4e"]])

export default __exports__